import TemplateView from '../../../../../TemplateView'
import Button from '../../../../../components/Button'
import messageResource from '../../../../../messageResource'
import CustomCheckbox from '../../../../../components/customCheckbox/CustomCheckbox'

export default class FinalFooter extends TemplateView {
    constructor({
        payButtonText = '',
        serviceAgreementLink = '',
        dataProcessingAgreementLink = '',
        onBackButtonClick = () => {},
        onPayButtonClick = () => {},
        onConfirmAgreementClick = () => {},
    }) {
        super()

        this.params = {
            serviceAgreementLink,
            dataProcessingAgreementLink,
        }

        this.callbacks = {
            onBackButtonClick,
            onPayButtonClick,
            onConfirmAgreementClick,
        }

        this.state = {
            payButtonText: payButtonText,
            disablePayButton: false,
            agreementsConfirmed: false,
            needConfirmAgreement: false,
            hideBackButton: false,
        }

        this.onStatePropertyChanged('payButtonText', (payButtonText) => {
            this.payButton.setState({label: payButtonText})
        })

        this.onStatePropertyChanged('disablePayButton', (disablePayButton) => {
            this.payButton.setState({disabled: disablePayButton})
        })

        this.onStatePropertyChanged('needConfirmAgreement', (needConfirmAgreement) => {
            this.$licensesAgreementCheck.toggle(needConfirmAgreement)
            this.getEl().toggleClass('withCheckbox', needConfirmAgreement)
        })

        this.onStatePropertyChanged('agreementsConfirmed', (agreementsConfirmed) => {
            this.licensesAgreement.setState({checked: agreementsConfirmed})
        })

        this.onStatePropertyChanged('hideBackButton', (hideBackButton) => {
            this.backButton.toggle(!hideBackButton)
        })
    }

    templateHtml() {
        return '<div class="finalFooter">' +
               '    <div class="licensesAgreementCheck"/>' +
               '    <div class="buttonContainer">' +
               '        <div class="backButton"/>' +
               '        <div class="payButton"/>' +
               '    </div>' +
               '</div>'
    }

    afterRender() {
        this.$licensesAgreementCheck = this.find('.licensesAgreementCheck')
        this.licensesAgreement = new CustomCheckbox({
            htmlLabel: messageResource.getMessage('licenses.purchase.purchase_step.agreement_text',
                [this.params.serviceAgreementLink, this.params.dataProcessingAgreementLink]),
            checkmarkAdditionalClass: 'agreementCheckmark',
            checkboxTitleAdditionalClass: 'agreementLabel',
            containerAdditionalClass: 'agreementCheckboxContainer',
            onChange: () => this.callbacks.onConfirmAgreementClick(!this.state.agreementsConfirmed),
        }).init(this.$licensesAgreementCheck)

        this.backButton = new Button({
            additionalClass: 'backButton cancelButton',
            label: messageResource.getMessage('licenses.purchase.purchase_step.back_button'),
            onClickCb: this.callbacks.onBackButtonClick,
        }).init(this.find('.buttonContainer'))

        this.payButton = new Button({
            additionalClass: 'pay',
            onClickCb: this.callbacks.onPayButtonClick,
        }).init(this.find('.buttonContainer'))

        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/paymentStep/FinalFooter.js